import React from 'react';
import { useSelector } from 'react-redux';
import { OfflineProvider } from './OfflineProvider';

/**
 * Wrapper component that extracts auth tokens from Redux
 * and provides them to OfflineProvider
 */
export const OfflineProviderWrapper = ({ children }) => {
  const loginData = useSelector((state) => state.loginData?.value);

  const authToken = loginData?.auth_token;
  const userToken = loginData?.user?.token;
  const orgId = loginData?.user?.org_id;

  return (
    <OfflineProvider
      authToken={authToken}
      userToken={userToken}
      orgId={orgId}
    >
      {children}
    </OfflineProvider>
  );
};
